import React from 'react';
import { Copy, Flex } from '@grubhubprod/gh-cookbook-react';
import { TableState } from 'src/components/DataTable/types/DataTable';
import { useDataTableContext } from 'src/components/DataTable/components/DataTableProvider/hooks/useDataTableContext';

export type DataTableNoResultsProps = {
  children?: (tableState: TableState) => React.ReactNode;
};

export const DataTableNoResults: React.FC<DataTableNoResultsProps> = ({
  children,
}) => {
  const { tableState, isEmpty, isLoading, isError, hasFilters } =
    useDataTableContext();

  if (!isEmpty || isLoading || isError || !hasFilters) {
    return null;
  }

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      width="100%"
      height="100%"
      minHeight="100px"
    >
      {children?.(tableState) ?? (
        <Copy variant="body" color="primaryText">
          No matching results.
        </Copy>
      )}
    </Flex>
  );
};
